import { Injectable, Output, EventEmitter, Directive } from '@angular/core';
import { SelectorServiceOutputModel } from '@shared/models/selector-service-output.model';

@Directive()
@Injectable()
export class SelectorService {

  @Output() selection: EventEmitter<any> = new EventEmitter<any>();
  @Output() selectObj: EventEmitter<any> = new EventEmitter<any>();

  sendMessage(obj: any) {
    this.selection.emit(obj);
  }

  send(obj: any) {
    this.selectObj.emit(obj);
  }
}
